export const compressImage = (file, { maxWidth = 1600, maxHeight = 1600, quality = 0.8 } = {}) => {
  return new Promise((resolve) => {
    // If it is not an image, return it as is
    if (!file || !file.type || !file.type.startsWith('image/')) {
      return resolve(file);
    }
    // Don't compress SVG files
    if (file.type === 'image/svg+xml') {
      return resolve(file);
    }

    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (event) => {
      const img = new Image();
      img.src = event.target.result;
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;

        // Calculate new dimensions
        if (width > height) {
          if (width > maxWidth) {
            height = Math.round((height * maxWidth) / width);
            width = maxWidth;
          }
        } else {
          if (height > maxHeight) {
            width = Math.round((width * maxHeight) / height);
            height = maxHeight;
          }
        }

        canvas.width = width;
        canvas.height = height;

        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);

        // Keep PNG transparency if it is PNG, otherwise output as jpeg
        const outputType = file.type === 'image/png' ? 'image/png' : 'image/jpeg';

        canvas.toBlob((blob) => {
          if (!blob) {
            return resolve(file);
          }
          // Convert Blob back to File
          const name = file.name.substring(0, file.name.lastIndexOf('.')) + (outputType === 'image/png' ? '.png' : '.jpg');
          const compressedFile = new File([blob], name, {
            type: outputType,
            lastModified: Date.now()
          });
          resolve(compressedFile);
        }, outputType, quality);
      };
      img.onerror = () => {
        resolve(file);
      };
    };
    reader.onerror = () => {
      resolve(file);
    };
  });
};
